<form [formGroup]="searchForm" id="search-form">
	<div class="search-container mb-3">
		<div class="row align-items-center">

			<div class="col-12 col-sm-auto mb-2 mb-sm-4">
				<app-search-select
					[data]="availableFilters"
					[disableSelect]="true"
					(selectedChange)="addFilter($event)"
					[disabled]="availableFilters.length === 0"
					tooltip="Add filters to further refine your search."
					i18n-tooltip
					title="Add Filter"
					i18n-title
					class="filter-select"
				></app-search-select>
			</div>

			<div class="col-12 mb-sm-4">
				<div class="row align-items-center">
					<div class="col-12">
						<div class="row">
							<div class="col-12 {{field.id}}" *ngFor="let field of selectedTextFilters; let i = index">
								<div class="row align-items-center">
									<div class="col-3">
										<app-search-select
											[data]="field.meta.filters.data"
											[selected]="field.id"
											(selectedChange)="editTextFilters($event, field)"
										></app-search-select>
									</div>

									<mat-form-field class="col" appearance="standard" floatLabel="always">
										<mat-label i18n>{{field.name}}</mat-label>
										<input
											matInput
											i18n-placeholder
											formControlName="{{field.id}}Control"
										>
									</mat-form-field>

									<div class="col-2 col-sm-auto">
										<button
											type="button"
											mat-icon-button
											color="warn"
											i18n
											(click)="removeTextFilter(i)"
											matTooltip="Remove field from search."
											i18n-matTooltip
											[disabled]="selectedTextFilters.length <= 1"
											class="text-filter-remove"
										>
											<mat-icon>delete</mat-icon>
										</button>
									</div>
								</div>
							</div>
						</div>
					</div>

					<div class="col-12 mb-3">
						<div class="mat-divider"></div>
					</div>

					<div class="col-12">
						<ng-container [ngSwitch]="filter.id" *ngFor="let filter of selectedFieldFilters">
							<ng-container *ngSwitchCase="'emailVerified'">
								<ng-container *ngTemplateOutlet="emailVerified"></ng-container>
							</ng-container>
							<ng-container *ngSwitchCase="'gender'">
								<ng-container *ngTemplateOutlet="gender"></ng-container>
							</ng-container>
							<ng-container *ngSwitchCase="'role'">
								<ng-container *ngTemplateOutlet="role"></ng-container>
							</ng-container>
							<ng-container *ngSwitchCase="'billingCountry'">
								<ng-container *ngTemplateOutlet="billingCountry"></ng-container>
							</ng-container>
							<ng-container *ngSwitchCase="'lastLogin'">
								<ng-container *ngTemplateOutlet="lastLogin"></ng-container>
							</ng-container>
							<ng-container *ngSwitchCase="'createdTime'">
								<ng-container *ngTemplateOutlet="createdTime"></ng-container>
							</ng-container>
						</ng-container>
					</div>

					<!-- Submit -->
					<div class="col-12 text-right mb-4 mt-2">
						<button
							[disabled]="searchForm.invalid"
							type="submit"
							mat-flat-button
							color="primary"
							i18n
							(click)="search()"
							class="float-right col-12 col-sm-auto mb-2 mb-sm-0"
						>Search</button>

						<button
							type="button"
							mat-flat-button
							color="warn"
							i18n
							(click)="clearSearch()"
							title="Reset search form."
							i18n-title
							class="float-right mr-sm-2 col-12 col-sm-auto reset-button"
						>Reset</button>
					</div>
					<!-- END Submit -->
				</div>
			</div>
		</div>
	</div>

	<!-- Email Verified Filter -->
	<ng-template #emailVerified>
		<button
			mat-flat-button
			[matMenuTriggerFor]="emailVerifiedMenu"
			color="{{ searchForm.controls.emailVerified.value === 'verified' || searchForm.controls.emailVerified.value === 'unverified' ? 'primary' : '' }}"
			[ngClass]="{'filter-button-alt': searchForm.controls.emailVerified.value !== 'verified' && searchForm.controls.emailVerified.value !== 'unverified'}"
			#emailVerifiedMenuTrigger ="matMenuTrigger"
			type="button"
			class="mb-2 mr-sm-2 col-12 col-sm-auto"
		>
			<mat-icon
				matTooltip="Filter users by email verification status."
				i18n-matTooltip
				class="mr-2"
				class="filter-tooltip-icon"
			>info</mat-icon>
			<ng-container *ngIf="searchForm.controls.emailVerified.value === 'all'"> Verification Status</ng-container>
			<ng-container *ngIf="searchForm.controls.emailVerified.value === 'verified'">Email Verified</ng-container>
			<ng-container *ngIf="searchForm.controls.emailVerified.value === 'unverified'">Email Unverified</ng-container>
			<mat-icon class="ml-2" *ngIf="emailVerifiedMenuTrigger?.menuOpen">keyboard_arrow_up</mat-icon>
			<mat-icon class="ml-2" *ngIf="!emailVerifiedMenuTrigger?.menuOpen">keyboard_arrow_down</mat-icon>

			<button type="button" title="Clear filter" i18n-title class="clear-button" (click)="removeFieldFilter($event, 'emailVerified')">
				<mat-icon>clear</mat-icon>
			</button>
		</button>
		<mat-menu #emailVerifiedMenu="matMenu" class="p-3">
			<div (click)="$event.stopPropagation();">
				<mat-form-field appearance="standard" floatLabel="always">
					<mat-label i18n>Select</mat-label>
					<mat-select formControlName="emailVerified">
						<mat-option value="all">Show All</mat-option>
						<mat-option value="verified" i18n>Verified</mat-option>
						<mat-option value="unverified" i18n>Unverified</mat-option>
					</mat-select>
				</mat-form-field>
			</div>
		</mat-menu>
	</ng-template>
	<!-- END Email Verified Filter -->

	<!-- Gender -->
	<ng-template #gender>
		<button
			mat-flat-button
			[matMenuTriggerFor]="gendersMenu"
			#gendersMenuTrigger ="matMenuTrigger"
			type="button"
			class="mb-2 mr-sm-2 col-12 col-sm-auto"
			color="{{ searchForm.controls.gender.value && searchForm.controls.gender.value !== 'all' ? 'primary' : '' }}"
			[ngClass]="{'filter-button-alt': !searchForm.controls.gender.value || searchForm.controls.gender.value === 'all'}"
		>
			<mat-icon
				matTooltip="Filter users on gender."
				i18n-matTooltip
				class="mr-2"
				class="filter-tooltip-icon"
			>info</mat-icon>
			<ng-container *ngIf="!searchForm.controls.gender.value || searchForm.controls.gender.value === 'all'" i18n> Gender</ng-container>
			<ng-container *ngIf="searchForm.controls.gender.value && searchForm.controls.gender.value !== 'all'" i18n>{{getLabel(searchForm.controls.gender.value, genders)}}</ng-container>
			<mat-icon class="ml-2" *ngIf="gendersMenuTrigger?.menuOpen">keyboard_arrow_up</mat-icon>
			<mat-icon class="ml-2" *ngIf="!gendersMenuTrigger?.menuOpen">keyboard_arrow_down</mat-icon>

			<button type="button" title="Clear filter" i18n-title class="clear-button" (click)="removeFieldFilter($event, 'gender')">
				<mat-icon>clear</mat-icon>
			</button>
		</button>
		<mat-menu #gendersMenu="matMenu" class="p-3">
			<div (click)="$event.stopPropagation();">
				<mat-form-field appearance="standard" floatLabel="always">
					<mat-label i18n>Select</mat-label>
					<mat-select formControlName="gender">
						<mat-option value="all">Show All</mat-option>
						<mat-option
							*ngFor="let gender of genders"
							[value]="gender.id"
						>{{gender.label}}</mat-option>
					</mat-select>
				</mat-form-field>
			</div>
		</mat-menu>
	</ng-template>
	<!-- END Gender -->

	<!-- Role -->
	<ng-template #role>
		<div
			class="mb-2 mr-sm-2 col-12 col-sm-auto mat-flat-button role-filter-container"
			[ngClass]="{'filter-button-alt': !searchForm.controls.role.value || searchForm.controls.role.value === 'all'}"
		>
			<app-search-select
				[data]="roles"
				[disableSelect]="false"
				(selectedChange)="this.searchForm.controls.role.setValue($event)"
				[selected]="searchForm.controls.role.value && searchForm.controls.role.value !== 'all' ? searchForm.controls.role.value : 'all'"
				tooltip="Filter users on role."
				i18n-tooltip
				title="Role"
				i18n-title
			></app-search-select>
			<button type="button" title="Clear filter" i18n-title class="clear-button" (click)="removeFieldFilter($event, 'role')">
				<mat-icon>clear</mat-icon>
			</button>
		</div>
	</ng-template>
	<!-- END Role -->

	<!-- Billing Country -->
	<ng-template #billingCountry>
		<button
			mat-flat-button
			[matMenuTriggerFor]="billingCountryMenu"
			#billingCountryMenuTrigger ="matMenuTrigger"
			type="button"
			class="mb-2 mr-sm-2 col-12 col-sm-auto"
			color="{{ searchForm.controls.billingCountry.value && searchForm.controls.billingCountry.value !== 'all' ? 'primary' : '' }}"
			[ngClass]="{'filter-button-alt': !searchForm.controls.billingCountry.value || searchForm.controls.billingCountry.value === 'all'}"
		>
			<mat-icon
				matTooltip="Filter users on billing country."
				i18n-matTooltip
				class="mr-2"
				class="filter-tooltip-icon"
			>info</mat-icon>
			<ng-container *ngIf="!searchForm.controls.billingCountry.value || searchForm.controls.billingCountry.value === 'all'" i18n> Billing Country</ng-container>
			<ng-container *ngIf="searchForm.controls.billingCountry.value && searchForm.controls.billingCountry.value !== 'all'" i18n>{{getLabel(searchForm.controls.billingCountry.value, countries)}}</ng-container>
			<mat-icon class="ml-2" *ngIf="billingCountryMenuTrigger?.menuOpen">keyboard_arrow_up</mat-icon>
			<mat-icon class="ml-2" *ngIf="!billingCountryMenuTrigger?.menuOpen">keyboard_arrow_down</mat-icon>

			<button type="button" title="Clear filter" i18n-title class="clear-button" (click)="removeFieldFilter($event, 'billingCountry')">
				<mat-icon>clear</mat-icon>
			</button>
		</button>

		<mat-menu #billingCountryMenu="matMenu" class="p-3">
			<div (click)="$event.stopPropagation();">
				<mat-form-field appearance="standard" floatLabel="always">
					<mat-label i18n>Select</mat-label>
					<mat-select formControlName="billingCountry">
						<mat-option value="all">Show All</mat-option>
						<mat-option
							*ngFor="let country of countries"
							[value]="country.id"
						>{{country.label}}</mat-option>
					</mat-select>
				</mat-form-field>
			</div>
		</mat-menu>
	</ng-template>
	<!-- END Billing Country -->

	<!-- Login Date Range Filter -->
	<ng-template #lastLogin>
		<button
			mat-flat-button
			[matMenuTriggerFor]="lastLoginRangeMenu"
			#lastLoginRangeMenuTrigger ="matMenuTrigger"
			color="{{ searchForm.controls.loginEndDateControl.value || searchForm.controls.loginStartDateControl.value ? 'primary' : '' }}"
			[ngClass]="{'filter-button-alt': !searchForm.controls.loginEndDateControl.value && !searchForm.controls.loginStartDateControl.value}"
			type="button"
			i18n
			class="mr-sm-2 mb-2 col-12 col-sm-auto"
		>
			<mat-icon
				matTooltip="Filter users by last login date."
				i18n-matTooltip
				class="mr-2"
				class="filter-tooltip-icon"
			>info</mat-icon>
			Last Login<ng-container *ngIf="searchForm.controls.loginEndDateControl.value || searchForm.controls.loginStartDateControl.value">:</ng-container>
			<ng-container *ngIf="searchForm.controls.loginEndDateControl.value || searchForm.controls.loginStartDateControl.value">
				{{searchForm.controls.loginStartDateControl.value ? getLocalizedDate(searchForm.controls.loginStartDateControl.value, false) : ''}} - {{searchForm.controls.loginEndDateControl.value ? getLocalizedDate(searchForm.controls.loginEndDateControl.value, false) : ''}}
			</ng-container>
			<mat-icon class="ml-2" *ngIf="lastLoginRangeMenuTrigger?.menuOpen">keyboard_arrow_up</mat-icon>
			<mat-icon class="ml-2" *ngIf="!lastLoginRangeMenuTrigger?.menuOpen">keyboard_arrow_down</mat-icon>

			<button type="button" title="Clear filter" i18n-title class="clear-button" (click)="removeFieldFilter($event, 'lastLogin')">
				<mat-icon>clear</mat-icon>
			</button>
		</button>

		<mat-menu #lastLoginRangeMenu="matMenu" class="p-3">
			<div (click)="$event.stopPropagation();">
				<mat-form-field appearance="standard" class="w-100">
					<mat-label i18n>Time Zone</mat-label>
					<mat-select formControlName="loginTimezone" (openedChange)="expandedTimezoneArea = ''">
						<mat-optgroup *ngFor="let timezoneArea of timezonesService.data.timezonesByArea | keyvalue">
							<button type="button" mat-flat-button (click)="toggleTimezoneGroup($event, timezoneArea.key)" [style.margin-left]="'-8px'">
								{{timezoneArea.key}}
								<span class="material-icons" *ngIf="expandedTimezoneArea !== timezoneArea.key">expand_more</span>
								<span class="material-icons" *ngIf="expandedTimezoneArea === timezoneArea.key">expand_less</span>
							</button>
							<mat-option *ngFor="let timezone of timezoneArea.value" [value]="timezone.id" [style.display]="expandedTimezoneArea === timezoneArea.key ? 'block' : 'none'">
								{{timezone.name}}
							</mat-option>
						</mat-optgroup>
					</mat-select>
					<mat-icon
						matTooltip="Use the selected timezone to calculate after and before date."
						i18n-matTooltip
						matSuffix
					>info</mat-icon>
				</mat-form-field>

				<mat-form-field appearance="standard" class="date-picker" floatLabel="always" (click)="loginStartDate.open()">
					<mat-label i18n>After</mat-label>
					<input matInput [matDatepicker]="loginStartDate" formControlName="loginStartDateControl" [max]="searchForm.controls.loginEndDateControl.value ? searchForm.controls.loginEndDateControl.value : null">
					<mat-datepicker-toggle class="d-inline-block" matSuffix [for]="loginStartDate"></mat-datepicker-toggle>
					<mat-datepicker-toggle class="d-inline-block" matSuffix *ngIf="searchForm.controls.loginStartDateControl.value" (click)="clearFilter($event, 'loginStartDate')">
						<mat-icon matDatepickerToggleIcon>delete</mat-icon>
					</mat-datepicker-toggle>
					<mat-datepicker disabled="false" #loginStartDate></mat-datepicker>
				</mat-form-field>
				<span class="ml-1 mr-1">-</span>
				<mat-form-field appearance="standard" class="date-picker" floatLabel="always" (click)="loginEndDate.open()">
					<mat-label i18n>Before</mat-label>
					<input matInput [matDatepicker]="loginEndDate" formControlName="loginEndDateControl" [min]="searchForm.controls.loginStartDateControl.value ? searchForm.controls.loginStartDateControl.value : null">
					<mat-datepicker-toggle class="d-inline-block" matSuffix [for]="loginEndDate"></mat-datepicker-toggle>
					<mat-datepicker-toggle class="d-inline-block" matSuffix *ngIf="searchForm.controls.loginEndDateControl.value" (click)="clearFilter($event, 'loginEndDate')">
						<mat-icon matDatepickerToggleIcon>delete</mat-icon>
					</mat-datepicker-toggle>
					<mat-datepicker disabled="false" #loginEndDate></mat-datepicker>
				</mat-form-field>
			</div>
		</mat-menu>
	</ng-template>
	<!-- END Login Date Range Filter -->

	<!-- Created Date Range Filter -->
	<ng-template #createdTime>
		<button
			mat-flat-button
			[matMenuTriggerFor]="createdTimeRangeMenu"
			#createdTimeRangeMenuTrigger ="matMenuTrigger"
			color="{{ searchForm.controls.createdEndDateControl.value || searchForm.controls.createdStartDateControl.value ? 'primary' : '' }}"
			[ngClass]="{'filter-button-alt': !searchForm.controls.createdEndDateControl.value && !searchForm.controls.createdStartDateControl.value}"
			type="button"
			i18n
			class="mr-sm-2 mb-2 col-12 col-sm-auto"
		>
			<mat-icon
				matTooltip="Filter users by created date."
				i18n-matTooltip
				class="mr-2"
				class="filter-tooltip-icon"
			>info</mat-icon>
			Created<ng-container *ngIf="searchForm.controls.createdEndDateControl.value || searchForm.controls.createdStartDateControl.value">:</ng-container>
			<ng-container *ngIf="searchForm.controls.createdEndDateControl.value || searchForm.controls.createdStartDateControl.value">
				{{searchForm.controls.createdStartDateControl.value ? getLocalizedDate(searchForm.controls.createdStartDateControl.value, false) : ''}} - {{searchForm.controls.createdEndDateControl.value ? getLocalizedDate(searchForm.controls.createdEndDateControl.value, false) : ''}}
			</ng-container>
			<mat-icon class="ml-2" *ngIf="createdTimeRangeMenuTrigger?.menuOpen">keyboard_arrow_up</mat-icon>
			<mat-icon class="ml-2" *ngIf="!createdTimeRangeMenuTrigger?.menuOpen">keyboard_arrow_down</mat-icon>

			<button type="button" title="Clear filter" i18n-title class="clear-button" (click)="removeFieldFilter($event, 'createdTime')">
				<mat-icon>clear</mat-icon>
			</button>
		</button>
		<mat-menu #createdTimeRangeMenu="matMenu" class="p-3">
			<div (click)="$event.stopPropagation();">
				<mat-form-field appearance="standard" class="w-100">
					<mat-label i18n>Time Zone</mat-label>
					<mat-select formControlName="createdTimezone" (openedChange)="expandedTimezoneArea = ''">
						<mat-optgroup *ngFor="let timezoneArea of timezonesService.data.timezonesByArea | keyvalue">
							<button type="button" mat-flat-button (click)="toggleTimezoneGroup($event, timezoneArea.key)" [style.margin-left]="'-8px'">
								{{timezoneArea.key}}
								<span class="material-icons" *ngIf="expandedTimezoneArea !== timezoneArea.key">expand_more</span>
								<span class="material-icons" *ngIf="expandedTimezoneArea === timezoneArea.key">expand_less</span>
							</button>
							<mat-option *ngFor="let timezone of timezoneArea.value" [value]="timezone.id" [style.display]="expandedTimezoneArea === timezoneArea.key ? 'block' : 'none'">
								{{timezone.name}}
							</mat-option>
						</mat-optgroup>
					</mat-select>
					<mat-icon
						matTooltip="Use the selected timezone to calculate after and before date."
						i18n-matTooltip
						matSuffix
					>info</mat-icon>
				</mat-form-field>

				<mat-form-field appearance="standard" class="date-picker" floatLabel="always" (click)="createdStartDate.open()">
					<mat-label i18n>After</mat-label>
					<input matInput [matDatepicker]="createdStartDate" formControlName="createdStartDateControl" [max]="searchForm.controls.createdEndDateControl.value ? searchForm.controls.createdEndDateControl.value : null">
					<mat-datepicker-toggle class="d-inline-block" matSuffix [for]="createdStartDate"></mat-datepicker-toggle>
					<mat-datepicker-toggle class="d-inline-block" matSuffix *ngIf="searchForm.controls.createdStartDateControl.value" (click)="clearFilter($event, 'createdStartDate')">
						<mat-icon matDatepickerToggleIcon>delete</mat-icon>
					</mat-datepicker-toggle>
					<mat-datepicker disabled="false" #createdStartDate></mat-datepicker>
				</mat-form-field>
				<span class="ml-1 mr-1">-</span>
				<mat-form-field appearance="standard" class="date-picker" floatLabel="always" (click)="createdEndDate.open()">
					<mat-label i18n>Before</mat-label>
					<input matInput [matDatepicker]="createdEndDate" formControlName="createdEndDateControl" [min]="searchForm.controls.createdStartDateControl.value ? searchForm.controls.createdStartDateControl.value : null">
					<mat-datepicker-toggle class="d-inline-block" matSuffix [for]="createdEndDate"></mat-datepicker-toggle>
					<mat-datepicker-toggle class="d-inline-block" matSuffix *ngIf="searchForm.controls.createdEndDateControl.value" (click)="clearFilter($event, 'createdEndDate')">
						<mat-icon matDatepickerToggleIcon>delete</mat-icon>
					</mat-datepicker-toggle>
					<mat-datepicker disabled="false" #createdEndDate></mat-datepicker>
				</mat-form-field>
			</div>
		</mat-menu>
	</ng-template>
	<!-- END Created Date Range Filter -->
</form>
